import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

// Days-since-last-check histogram. Buckets ≤60 days render green
// (on-schedule), >60 days render red (overdue). The "Never" bucket is
// neutral gray.
export default class extends Controller {
  static values = { buckets: Object }

  connect() {
    const buckets = this.bucketsValue || {}
    const categories = Object.keys(buckets)
    const values = categories.map((k) => buckets[k])

    if (categories.length === 0) return

    const colors = categories.map((label) => {
      if (label === "Never") return "#9CA3AF"
      if (label === "61–90" || label === "91–180" || label === "180+") return "#DC2626"
      return "#059669"
    })

    const options = {
      chart: {
        type: "bar",
        height: 240,
        toolbar: { show: false },
        fontFamily: "'Neue Haas Grotesk Text Pro','DM Sans',sans-serif"
      },
      series: [{ name: "Hospitals", data: values }],
      plotOptions: {
        bar: {
          borderRadius: 3,
          columnWidth: "70%",
          distributed: true
        }
      },
      colors: colors,
      xaxis: {
        categories: categories,
        title: { text: "Days since last check", style: { color: "#6B7280", fontSize: "11px", fontWeight: 500 } },
        labels: { style: { colors: "#9CA3AF", fontSize: "11px" } },
        axisBorder: { color: "#E5E7EB" }
      },
      yaxis: {
        labels: { style: { colors: "#9CA3AF", fontSize: "11px" } }
      },
      grid: { borderColor: "#F0F1F3", strokeDashArray: 3 },
      dataLabels: {
        enabled: true,
        style: { fontSize: "11px", colors: ["#374151"] },
        offsetY: -18,
        formatter: (v) => v.toLocaleString()
      },
      legend: { show: false },
      tooltip: {
        y: { formatter: (v) => `${v.toLocaleString()} hospitals` }
      }
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }

  disconnect() {
    if (this.chart) this.chart.destroy()
  }
}
